import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/SimpleAuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import SimpleDashboard from './pages/SimpleDashboard';
import DividendHistory from './pages/DividendHistory';
import TokenLocking from './pages/TokenLocking';
import Profile from './pages/Profile';
import AuthCallback from './pages/AuthCallback';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <div className="min-h-screen bg-black dark:bg-black">
              <Navbar />
            <main>
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                
                {/* Protected Routes */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <SimpleDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/dividends"
                  element={
                    <ProtectedRoute>
                      <DividendHistory />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/token-locking"
                  element={
                    <ProtectedRoute>
                      <TokenLocking />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            
            {/* Toast notifications */}
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#111111',
                  color: '#ffffff',
                  border: '1px solid #333333',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#ffffff',
                    secondary: '#000000',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ffffff',
                    secondary: '#000000',
                  },
                },
              }}
            />
          </div>
        </Router>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App; 